import { trigger, state, style, transition, animate } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnChanges, signal} from '@angular/core';
import { MatExpansionModule} from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';

/**
 * @title Basic expansion panel
 */
@Component({
    selector: 'expansion-overview-example',
    standalone: true,
    templateUrl: 'expansion-settings.html',
    imports: [MatExpansionModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpansionOverviewExample implements OnChanges{
    @Input() textoExpansion!: string;

    furtherInformation = "features.privacySettings.furtherInformation";
    lessInformation = "features.privacySettings.lessInformation";
    text = this.furtherInformation;

    readonly panelOpenState = signal(false);

    ngOnChanges() {

    }

    click() {
        if(this.text == this.furtherInformation){
            this.text = this.lessInformation;
        } else {
            this.text = this.furtherInformation;
        }
    }
}


/**  Copyright 2025 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license */